// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gas-cost-calculator {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
}

.input-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
  border: 1px solid #ccc;
  padding: 20px;
}

.input-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.input-group label {
  display: flex;
  flex-direction: column;
  font-weight: bold;
  text-align: left;
}

.input-group input,
.input-group select {
  padding: 8px;
  font-size: 1em;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-top: 5px;

}

.gas-cost-calculator select{
  width: 100%;
  padding: 10px 0px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.ev-cost select{
  width: 100%;
  padding:8px 0px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.calculate-button {
  padding: 10px;
  font-size: 1em;
  font-weight: bold;
  color: #fff;
  background-color: #28a745;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  width: 100%;
  margin: 10px 0px;
}

.calculate-button:hover {
  background-color: #218838;
}

.calculate-button:active {
  background-color: #1e7e34;
}

.gas-cost-calculator .fuel-type-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.gas-cost-calculator .fuel-button {
  padding: 5px 15px;
  font-size: 0.9em;
  font-weight: bold;
  color: #fff;
  background-color: #007bff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.3s ease;
  flex: 1 1;
  text-align: center;
}

.gas-cost-calculator .fuel-button:hover {
  background-color: #0056b3;
}

.gas-cost-calculator .fuel-button:active {
  background-color: #004494;
}

.gas-cost-calculator .fuel-button.active {
  background-color: #004494;
}

.cost-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

.cost-table th, .cost-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}

.cost-table th {
  background-color: #f2f2f2;
  font-weight: bold;
  cursor: pointer;
}

.cost-table th:hover {
  background-color: #e0e0e0;
}

.cost-results {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.cost-block {
  flex: 1 1;
  text-align: center;
  background-color: #007bff;
  color: #fff;
  border-radius: 10px;
  margin-right: 10px;
  margin-left: 10px;
}


.cost-block h3 {
  margin-bottom: 10px;
}

.cost-block p {
  font-size: 1.5em;
  font-weight: bold;
}

@media (min-width: 600px) {
  .input-group {
    flex-direction: row;
  }

  .input-group label {
    flex: 1 1;
  }
}

@media (max-width: 600px) {
  .input-container {
    gap: 5px;
  }

  .fuel-button {
    padding: 8px 10px;
    font-size: 0.8em;
  }

  .gas-cost-calculator select {
    margin-top: 12px;
}


  .cost-table th, .cost-table td {
    padding: 6px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/GasCostCalculator.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;;AAEjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,2DAA2D;EAC3D,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;;AAGA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAO;EACT;AACF;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;AACpB;;;EAGE;IACE,YAAY;EACd;AACF","sourcesContent":[".gas-cost-calculator {\n  padding: 20px;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.input-container {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 20px;\n  border: 1px solid #ccc;\n  padding: 20px;\n}\n\n.input-group {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.input-group label {\n  display: flex;\n  flex-direction: column;\n  font-weight: bold;\n  text-align: left;\n}\n\n.input-group input,\n.input-group select {\n  padding: 8px;\n  font-size: 1em;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  margin-top: 5px;\n\n}\n\n.gas-cost-calculator select{\n  width: 100%;\n  padding: 10px 0px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}\n\n.ev-cost select{\n  width: 100%;\n  padding:8px 0px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}\n\n.calculate-button {\n  padding: 10px;\n  font-size: 1em;\n  font-weight: bold;\n  color: #fff;\n  background-color: #28a745;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  width: 100%;\n  margin: 10px 0px;\n}\n\n.calculate-button:hover {\n  background-color: #218838;\n}\n\n.calculate-button:active {\n  background-color: #1e7e34;\n}\n\n.gas-cost-calculator .fuel-type-buttons {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.gas-cost-calculator .fuel-button {\n  padding: 5px 15px;\n  font-size: 0.9em;\n  font-weight: bold;\n  color: #fff;\n  background-color: #007bff;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.3s ease;\n  flex: 1;\n  text-align: center;\n}\n\n.gas-cost-calculator .fuel-button:hover {\n  background-color: #0056b3;\n}\n\n.gas-cost-calculator .fuel-button:active {\n  background-color: #004494;\n}\n\n.gas-cost-calculator .fuel-button.active {\n  background-color: #004494;\n}\n\n.cost-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 20px;\n}\n\n.cost-table th, .cost-table td {\n  border: 1px solid #ddd;\n  padding: 8px;\n  text-align: center;\n}\n\n.cost-table th {\n  background-color: #f2f2f2;\n  font-weight: bold;\n  cursor: pointer;\n}\n\n.cost-table th:hover {\n  background-color: #e0e0e0;\n}\n\n.cost-results {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 20px;\n}\n\n.cost-block {\n  flex: 1;\n  text-align: center;\n  background-color: #007bff;\n  color: #fff;\n  border-radius: 10px;\n  margin-right: 10px;\n  margin-left: 10px;\n}\n\n\n.cost-block h3 {\n  margin-bottom: 10px;\n}\n\n.cost-block p {\n  font-size: 1.5em;\n  font-weight: bold;\n}\n\n@media (min-width: 600px) {\n  .input-group {\n    flex-direction: row;\n  }\n\n  .input-group label {\n    flex: 1;\n  }\n}\n\n@media (max-width: 600px) {\n  .input-container {\n    gap: 5px;\n  }\n\n  .fuel-button {\n    padding: 8px 10px;\n    font-size: 0.8em;\n  }\n\n  .gas-cost-calculator select {\n    margin-top: 12px;\n}\n\n\n  .cost-table th, .cost-table td {\n    padding: 6px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
